module.exports = exports = {
  // 台北車站微風
  BreezeTaipeiStation: {
    ticketCode: (counterNo, amount) => {
      // 2086000000453 共13碼
      // 偶位數相加值*3= 33
      // 奇位數相加值= 14
      // eslint-disable-next-line no-tabs
      // 相加=	47
      //  10-相加的個位數 =3

      if (counterNo.length !== 5 && amount.toString().length > 6) {
        return false;
      }
      const amountString = `000000${amount.toString()}`;
      const codeString = `2${counterNo}${amountString.substring(amountString.length - 6)}`;
      // [even, odd]
      let oddEvenSumArray = codeString.split('').reduce((accumulator, currentValue, currentIndex) => {
        const _sum = [...accumulator];
        // even or odd
        _sum[(currentIndex + 1) % 2] += parseInt(currentValue, 10);
        return _sum;
      }, [0, 0]);
      oddEvenSumArray = [oddEvenSumArray[0] * 3, oddEvenSumArray[1]]; // 偶數和x3
      const digit = (oddEvenSumArray[0] + oddEvenSumArray[1]) % 10; // 相加取個位數
      const checksum = 10 - digit;
      return codeString + checksum.toString();
    },
  },
};
